import { render, staticRenderFns } from "./LoadingTaskPage.vue?vue&type=template&id=18a97099&scoped=true"
import script from "./LoadingTaskPage.vue?vue&type=script&lang=js"
export * from "./LoadingTaskPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a97099",
  null
  
)

export default component.exports